/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-25 13:12:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-09 11:29:17
 * @FilePath: /src/components/Pay/WalletPay/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Currency } from '@/api/types/public';
import { IUseWallet } from '@/app/(payment)/payment/ClientPage';
import AboutMyWallet from '@/app/account/my-wallet/components/AboutMyWallet';
import Radio from '@/components/Form/Radio';
import Image from '@/components/Image';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { QuestionOutlined } from '@zeelool/icon';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslations } from 'next-intl';

interface WalletPayProps {
  walletBalance: string;
  walletPayAmount: string;
  payAmountWithWallet: string;
  loading: boolean;
  onChange: (isUseWallet: IUseWallet) => void;
  className?: string;
  isMobile?: boolean;
}

const renderCheckbox = (
  walletBalance: string,
  currency: Currency,
  setOpen: (open: boolean) => void,
  t: (key: string) => string,
) => {
  return (
    <div className="md:rounded-20 flex items-center md:ml-[16px]">
      <Image
        src="/payment/wallet.png"
        alt=""
        width={60}
        height={40}
        className="mr-18 w-[38px] md:w-[60px] h-fit md:h-[40px] max-w-[60px] m-h-[40px]"
      />
      <div className="">
        <span className="font-bb text-[14px] md:text-16">{t('myStoreCredit')}</span>
        <div className="text-auxiliary-text text-12 md:text-16 md:leading-[19px] leading-[14px] font-br flex items-center flex-wrap">
          <span> {t('availableBalance')} </span>
          <span className="flex items-center">
            <span className="">{formatPriceNumberWithSymbol(walletBalance, currency)}</span>
            <QuestionOutlined
              onClick={(e) => {
                e.preventDefault();
                setOpen(true);
              }}
              className="text-14 ml-4"
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default function WalletPay({
  walletBalance,
  walletPayAmount,
  payAmountWithWallet,
  loading,
  onChange,
  className,
  isMobile,
}: WalletPayProps) {
  const t = useTranslations('payment.WalletPay');

  const form = useForm();
  const currency = useStore((state) => state.currency);

  const { control } = form;

  const [isChecked, setIsChecked] = useState(false);
  const [open, setOpen] = useState(false);

  const handleCheckboxChange = (checked: boolean) => {
    setIsChecked(checked);
    onChange(checked ? IUseWallet.USE : IUseWallet.NOT_USE);
  };

  return (
    <div className="md:mb-20">
      <div
        className={`${className} ${isChecked ? 'bg-[#e3ebff] border-1 md:border-2 !rounded-10 border-[#463ae8]' : 'border-t-1 md:border-1 border-[#ccc]'} rounded-none md:rounded-10  `}
      >
        <Radio
          control={control}
          name="is_checked"
          label={renderCheckbox(walletBalance, currency, setOpen, t)}
          checked={isChecked}
          labelPlacement={isMobile ? 'start' : 'end'}
          iconSize={20}
          onClick={() => {
            handleCheckboxChange(!isChecked);
          }}
          sx={{
            padding: {
              md: '16px 20px',
              xs: '16px 6px',
            },
            width: '100%',
            margin: 0,
            '& .MuiRadio-root': {
              width: '20px',
              height: '20px',
              padding: 0,
            },
            '& .MuiFormControlLabel-label': {
              width: '100%',
              flexGrow: 1,
            },
            ...(isMobile && {
              '& .MuiCheckbox-root': {
                padding: 0,
              },
            }),
          }}
        />
      </div>
      {/* 全部使用钱包的钱  */}
      {isChecked && parseFloat(payAmountWithWallet) === 0 && !loading && (
        <section className="text-16 md:text-18 font-br leading-[20px] md:leading-28 my-20">
          <div className="use-wallet-desc">
            {t('payWith')}{' '}
            <span className="notranslate">
              {formatPriceNumberWithSymbol(walletPayAmount, currency)}
            </span>{' '}
            {t('storeCreditBalance')}
          </div>
        </section>
      )}

      {/* 部分使用钱包的钱  */}
      {isChecked && parseFloat(payAmountWithWallet) > 0 && !loading && (
        <section className="text-14 md:text-18 font-br leading-[22px] md:leading-28 my-20">
          <div className="use-wallet-desc">
            {t('payWith')}{' '}
            <span className="notranslate">
              {formatPriceNumberWithSymbol(walletPayAmount, currency)}
            </span>{' '}
            {t('withStoreCreditBalancePaymentMethodForResidual')}{' '}
            <span className="notranslate">
              {formatPriceNumberWithSymbol(payAmountWithWallet, currency)}
            </span>
          </div>
        </section>
      )}
      <AboutMyWallet open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
